import { render } from "./ResetPassword.vue?vue&type=template&id=9ab07378"
import script from "./ResetPassword.vue?vue&type=script&lang=js"
export * from "./ResetPassword.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/retail.interapptive.media/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__